import React, { FC, useCallback, useMemo, useState } from 'react';
import { Control, Controller } from 'react-hook-form';

import * as S from './style';

import Modal from '../../../common/Modal/Modal';

interface Props {
  isShow: boolean;
  onRequestClose: () => void;
  onClick: () => void;
  control: Control<{ otpCode: string }>;
}

const ModalOTPCheck: FC<Props> = ({
  isShow,
  onRequestClose,
  onClick,
  control,
}) => {
  const [valueLength, setValueLength] = useState(0);

  const handleChange = useCallback(
    (evt: React.ChangeEvent<HTMLInputElement>) => {
      const { target } = evt;

      if (target.value.length > target.maxLength) {
        target.value = target.value.slice(0, target.maxLength);
      }
      return target.value;
    },
    [],
  );

  const handleKeyDown = useCallback(
    (evt: React.KeyboardEvent<HTMLInputElement>) => {
      if ([`-`, `+`, `e`, `E`, `.`].includes(evt.key) || evt.keyCode === 229) {
        evt.preventDefault();
      }
    },
    [],
  );

  const handleInputChange = useCallback(
    (field, evt: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = evt.target;

      setValueLength(value.length);
      field.onChange(handleChange(evt));
    },
    [setValueLength, handleChange],
  );

  const modalForm = useMemo(() => {
    return (
      <S.Form onSubmit={onClick}>
        <Controller
          name="otpCode"
          control={control}
          render={({ field }) => (
            <S.InputArea>
              <S.Input
                type="number"
                {...field}
                onChange={(evt) => handleInputChange(field, evt)}
                maxLength={6}
                onKeyDown={handleKeyDown}
                style={{ cursor: `text` }}
              />
            </S.InputArea>
          )}
        />
      </S.Form>
    );
  }, [onClick, control, handleInputChange, handleKeyDown]);

  return (
    <Modal
      size="fit"
      isShow={isShow}
      title="Verification code"
      onClose={onRequestClose}
      explanation={
        <>
          Enter a 6-digit verification code generated by an authentication app.
          {` `}
          <br />
          Please use the OTP account you set up through the K STADIUM app.
        </>
      }
      headerComponentExtended={modalForm}
      footerComponent={
        <button
          onClick={onClick}
          className="btn btn-block btn-primary btn-lg"
          disabled={valueLength < 6}
        >
          OK
        </button>
      }
    />
  );
};

export default ModalOTPCheck;
